export const BASE_URL='/api' // for build // for [prod]
// export const BASE_URL='http://localhost/api' // for local
export const HOSPITAL_DETAILS_URL='/hospital/hospitaldetails'
export const AVAILABLE_SLOTS='/availableslots'